import { create } from 'zustand';

import { NotificationResponse } from '@/api/data-contracts';

export interface ToastNotification {
  id: string;
  notification: NotificationResponse;
  addedAt: number;
}

const MAX_VISIBLE = 2;
const AUTO_DISMISS_MS = 10000;

interface NotificationToastsState {
  toasts: ToastNotification[];
  addToast: (notification: NotificationResponse) => void;
  removeToast: (id: string) => void;
  clearAll: () => void;
}

const useNotificationToastsStore = create<NotificationToastsState>()((set) => ({
  toasts: [],
  addToast: (notification) =>
    set((state) => ({
      toasts: [
        ...state.toasts,
        {
          id: `${notification.id}-${Date.now()}`,
          notification,
          addedAt: Date.now(),
        },
      ],
    })),
  removeToast: (id) =>
    set((state) => ({
      toasts: state.toasts.filter((t) => t.id !== id),
    })),
  clearAll: () => set({ toasts: [] }),
}));

export { MAX_VISIBLE, AUTO_DISMISS_MS };
export default useNotificationToastsStore;
